<template>
  <div>
    <el-dialog title="我的素材" :visible.sync="showImgSelect" width='880px'>
      <el-tabs tab-position="left" v-model='type_nav' @tab-click='change_type_nav' style="height: 520px;">
        <el-tab-pane label="图片素材" name='图片'>
          <div class="topbar">
            <el-upload class="upload-demo" :action="getUpload" multiple :show-file-list='false' :on-success='upload_img_success'>
              <el-button size="small" type="primary">上传图片</el-button>
            </el-upload>
            <el-button size="small" style='margin-left: 20px' @click='add_group()' type="">添加分组</el-button>
            <el-dropdown size="small"  style='margin-left: 10px' trigger="click" @command='change_order_by'>
              <el-button  size='small' >
                {{filter.order_by}}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='按时间升序'>按时间升序</el-dropdown-item>
                <el-dropdown-item command='按时间降序'>按时间降序</el-dropdown-item>
                <el-dropdown-item command='按文件名升序'>按文件名升序</el-dropdown-item>
                <el-dropdown-item command='按文件名降序'>按文件名降序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-checkbox label="编辑模式" @change='change_edit_mode' v-model='edit_mode' style='margin-right: 10px;margin-left: 10px' size='small' border></el-checkbox>
            <template v-if='edit_mode'>
              <el-checkbox :indeterminate="img_check_more" v-model='img_check_all' @change='change_check_all' style='margin-left: 0;margin-right: 10px' border size='small' >全选</el-checkbox>
              <el-dropdown size="small" trigger="click"  @command="move_to_group" >
                <el-button  size='small' >
                  移动至分组<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item :command='item.id' v-for='(item,index) in img_group' :key='item.id'>{{item.title}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button size="small" style='margin-left: 10px' @click='del_img_mult' type="danger">批量删除</el-button>
            </template>
          </div>
          <el-tabs v-model='filter.group_id' type='card' size='small' @tab-click='page_img=1;getImglist()'  @tab-remove="del_group" >
            <el-tab-pane label="未分组" name="0" ></el-tab-pane>
            <el-tab-pane v-for='( item ,index ) in img_group' closable :name='item.id' :label="item.title" :key='item.id'></el-tab-pane>
          </el-tabs>
          <div class="myimg">
            <div v-if='myimg.length==0' class="nulllist">
              <svg-icon class='icon' icon-class='nulllist'/>
            </div>
            <div v-else class="imgbox_">
              <div class="section" v-for='(img,i) in myimg'>
                <div class="delImg" @click='delMyImg(img,i)'><svg-icon class='icon' icon-class='close'/></div>
                <div class="img" :class='img.check? "imgon":""' @click='checkSection(img)'>
                  <el-image :src='siteUrl+img.url'>
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                  <!-- <img :src="siteUrl+img.url" alt=""> -->
                  <div class="bottom">
                    <div class="check" ><svg-icon class='icon' icon-class='check'/></div>
                  </div>
                </div>
                <div class="label" @click='reset_name(img)'>{{img.name}}</div>
              </div>
            </div>
          </div>
          <div class="mbtns1">
            <el-pagination small layout="prev, pager, next" @current-change='changeImgPage' :page.sync='page_img' :page-size='15' :total="myimgCount"></el-pagination>
          </div>

        </el-tab-pane>
        <el-tab-pane label="视频素材" name='视频'>
          <div class="topbar">
            <el-upload class="upload-demo" :action="getUpload_video"  :show-file-list='true' multiple :on-success='get_video_list'>
              <el-button size="small" type="primary" >上传视频</el-button>
            </el-upload>
            <el-button size="small" style='margin-left: 20px' @click='add_group("video")' type="">添加分组</el-button>
            <el-dropdown size="small"  style='margin-left: 10px' trigger="click" @command='change_order_by'>
              <el-button  size='small' >
                {{filter.order_by}}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='按时间升序'>按时间升序</el-dropdown-item>
                <el-dropdown-item command='按时间降序'>按时间降序</el-dropdown-item>
                <el-dropdown-item command='按文件名升序'>按文件名升序</el-dropdown-item>
                <el-dropdown-item command='按文件名降序'>按文件名降序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-checkbox label="编辑模式" @change='change_edit_mode' v-model='edit_mode' style='margin-right: 10px;margin-left: 10px' size='small' border></el-checkbox>
            <template v-if='edit_mode'>
              <el-checkbox :indeterminate="video_check_more" v-model='video_check_all' @change='change_check_all' style='margin-left: 0;margin-right: 10px' border size='small' >全选</el-checkbox>
              <el-dropdown size="small" trigger="click"  @command="move_to_group" >
                <el-button  size='small' >
                  移动至分组<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" >
                  <el-dropdown-item :command='item.id' v-for='(item,index) in video_group' :key='item.id'>{{item.title}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button size="small" style='margin-left: 10px' @click='del_img_mult' type="danger">批量删除</el-button>
            </template>
          </div>
          <el-tabs v-model='filter.group_id_video' type='card' size='small' @tab-click='page_video=1;get_video_list()'  @tab-remove="del_group" >
            <el-tab-pane label="未分组" name="0" ></el-tab-pane>
            <el-tab-pane v-for='( item ,index ) in video_group' closable :name='item.id' :label="item.title" :key='item.id'></el-tab-pane>
          </el-tabs>
          <el-form label-width='200'>
            <div class="myimg">
              <div v-if='myvideo.length==0' class="nulllist">
                <svg-icon class='icon' icon-class='nulllist'/>
              </div>
              <div v-else class="imgbox_">
                <div class="section" v-for='(img,i) in myvideo'>
                  <div class="delImg" @click='del_video(img,i)'><svg-icon class='icon' icon-class='close'/></div>
                  <div class="img" :class='img.check? "imgon":""' @click='checkSection(img)'>
                    <div class="video_icon" @dbclick='play_video(img)'><svg-icon class='icon' icon-class='play_video'/></div>
                    <video v-if='img.url' :src="img.url"></video>
                    <div class="bottom">
                      <div class="check"><svg-icon class='icon' icon-class='check'/></div>
                    </div>
                  </div>
                  <div class="label" @click='reset_name(img,"video")'>{{img.name}}</div>
                </div>
              </div>
            </div>
            <div class="mbtns1">
              <el-pagination small layout="prev, pager, next" @current-change='changevideoPage' :page='page_video' :page-size='15' :total="myvideoCount"></el-pagination>
            </div>
          </el-form>

        </el-tab-pane>
      </el-tabs>

      <div v-if='select_video'>

      </div>
      <div v-else>
        <el-form label-width='200'>
          <div class="mbtns1">
            <div class="left">
              <el-button size='medium' @click='selectimgSuccess' type='primary'>确定</el-button>
              <el-button size='medium' @click='showImgSelect=false'>取消</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>


  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {getImglist,getUpload,getUpload_video,add_group,del_group ,get_video_list,del_video,move_to_group,del_img_mult,del_video_mult,reset_name,delMyImg} from "@/api/api"
  import Cookies from 'js-cookie'
  let path = location.hash+"_diyapp";
  let filter = Cookies.get(path) ? JSON.parse(Cookies.get(path)):{
    order_by:"按时间降序",
    group_id:0,
    group_id_video:0
  }
  export default{
    data(){
      console.log(this.$store.state.media)
      return{
        img_group:[],
        filter,
        getUpload:getUpload(),
        getUpload_video:getUpload_video(),
        myimg:[],
        video_group:[],
        img_check_more:false,
        img_check_all:false,
        video_check_more:false,
        video_check_all:false,
        edit_mode:false,
        myvideo:[],
        myvideoCount:0,
        select_video:false,
        myimgCount:0,
        page_img:1,
        page_video:1,
      }
    },
    watch:{
      "myimg":{
        handler(val){
          let checknum = 0;
          this.myimg.forEach(val=>{
            if (val.check) {
              checknum ++
            }
          })
          if(this.myimg.length>checknum && checknum>0){
            this.img_check_more = true;
          }
          else if(this.myimg.length == checknum ){
            this.img_check_more = false;
            this.$set(this,'img_check_all',true)
          }
          else{
            this.img_check_more = false;
          }

        },
        deep:true
      },
      "myvideo":{
        handler(val){
          let checknum = 0;
          this.myvideo.forEach(val=>{
            if (val.check) {
              checknum ++
            }
          })
          if(this.myvideo.length>checknum && checknum>0){
            this.img_check_more = true;
          }
          else if(this.myvideo.length == checknum ){
            this.img_check_more = false;
            this.$set(this,'img_check_all',true)
          }
          else{
            this.img_check_more = false;
          }

        },
        deep:true
      },
      "showImgSelect":{
        handler(val){
          if(val){
            this.getImglist();
            this.get_video_list();
          }
        }
      }
    },
    computed: {
      type_nav:{
        get(){ return this.$store.state.media.type_nav  },
        set(e){ return this.$store.commit('change_type_nav',e) }
      },
      showImgSelect:{
        get(){ return this.$store.state.media.showImgSelect  },
        set(){ return this.$store.commit('change_show_select_img') }
      },
      mult:{
        get(){ return this.$store.state.media.mult }
      }
// ...mapGetters([
//   'showImgSelect',
//   ])
},
mounted(){
},
methods:{
  change_type_nav(){
  },
  change_check_all(e){
    if(this.type_nav=="视频"){
      this.myvideo.forEach(val=>{
        val.check = e; 
      })
    }
    else{
      this.myimg.forEach(val=>{
        val.check = e; 
      })
    }
  },
  change_order_by(e){
    this.filter.order_by = e;
    if(this.type_nav=="视频"){
      this.get_video_list();
    }else{
      this.getImglist();
    }
  },
  reset_name(item,where){
    this.$prompt('输入新的文件名', '重命名', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputValue:item.name
    }).then(({ value }) => {
      reset_name({id:item.id,name:value,type:where},this,res=>{
        this.$message({
          type: 'success',
          message: res.data.msg
        });
        this.getImglist();
        this.get_video_list();
      })
    }).catch(() => {    
    });
  },
  change_edit_mode(e){
    if(!e){
      if(this.type_nav=="视频"){
        this.myvideo.forEach(val=>{
          val.check = false;
        })
      }
      else{
        this.myimg.forEach(val=>{
          val.check = false;
        })
      }
    }
  },
  selectimgSuccess(){
    let select = [];
    if(this.type_nav=="视频"){
      this.myvideo.forEach(val=>{
        if(val.check){
          select.push(val.url)
        }
      })
    }
    else{
      this.myimg.forEach(val=>{
        if(val.check){
          select.push(this.siteUrl+val.url)
        }
      })
    }
    this.$store.commit("selectimgSuccess",{type:this.type_nav,list:select})
  },
  del_img_mult(){
    let ids = [];
    if(this.type_nav=="视频"){
      this.myvideo.forEach(val=>{
        if(val.check){
          ids.push(val.id)
        }
      })
    }
    else{
      this.myimg.forEach(val=>{
        if(val.check){
          ids.push(val.id)
        }
      })
    }
    if(ids.length ==0){
      this.$message({
        type:'info',
        message:"至少选中一个素材"
      })
      return
    }
    ids = ids.join(",")
    this.$confirm('确认删除选中素材?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if(this.type_nav=="视频"){
        del_video_mult({ids},this,res=>{
          this.$message({
            type:'success',
            message:res.data.msg
          })
          this.get_video_list();
        })
      }
      else{
        del_img_mult({ids},this,res=>{
          this.$message({
            type:'success',
            message:res.data.msg
          })
          this.getImglist();
        })
      }
    }).catch(() => {
    });
  },
  move_to_group(id){
    let ids = [];
    if(this.type_nav=="视频"){
      this.myvideo.forEach(val=>{
        if(val.check){
          ids.push(val.id)
        }
      })
    }else{
      this.myimg.forEach(val=>{
        if(val.check){
          ids.push(val.id)
        }
      })
    }
    if(ids.length ==0){
      this.$message({
        type:'info',
        message:"至少选中一个素材"
      })
      return
    }
    ids = ids.join(",")
    if(this.type_nav=="视频"){
      move_to_group({id,ids,type:1},this,res=>{
        this.$message({
          type:'success',
          message:res.data.msg
        })
        this.get_video_list();
      })
    }
    else{
      move_to_group({id,ids},this,res=>{
        this.$message({
          type:'success',
          message:res.data.msg
        })
        this.getImglist();
      })
    }
  },
  checkSection(item){
    console.log(item)
    if(item.check){
      item.check = false;
      return
    }
    if(this.edit_mode){
      item.check = true;
    }
    else if(this.mult){
      let select_num = 0;
      if(this.type_nav=="视频"){
        this.myvideo.forEach(val=>{
          if(val.check) {
            select_num++
          }
        })
      }
      else{
        this.myimg.forEach(val=>{
          if(val.check) {
            select_num++
          }
        })
      }
      if(this.mult === true){
        item.check = true;
      }
      else if(typeof(this.mult) =="number" && select_num < this.mult ){
        item.check = true;
        // if(select_num+1 == this.mult){
        // 	this.selectimgSuccess()
        // }
      }
      else{
        this.$message({
          type:'info',
          message:'当前还可添加'+this.mult+"张图片"
        })
      }

    }
    else{
      if(this.type_nav=="视频"){
        this.myvideo.forEach(val=>{
          val.check = false;
        })
      }
      else{
        this.myimg.forEach(val=>{
          val.check = false;
        })
      }
      item.check = true;
      this.selectimgSuccess()
    }
    this.$set(this,'myvideo',JSON.parse(JSON.stringify(this.myvideo)))
    this.$set(this,'myimg',JSON.parse(JSON.stringify(this.myimg)))
  },
  upload_img_success(res){
    if(res.status==-1){
      this.$message({
        type:'info',
        message:res.msg
      })
    }
    this.getImglist();
  },
  add_group(where){
    this.$prompt('请输入分组名称', '添加分组', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    }).then(({ value }) => {
      add_group({title:value,type:where},this,res=>{
        this.$message({
          type: 'success',
          message: res.data.msg
        });
        this.getImglist();
      })
    }).catch(() => {    
    });
  },
  del_group(item){
    this.$confirm('确认删除此分组, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      del_group({id:item,type:this.type_nav=="视频"?1:0},this,res=>{
        this.$message({
          type: 'success',
          message: res.data.msg
        });
        this.getImglist();
      })
    }).catch(() => {
    });
  },
  delMyImg(item,index){
    this.$confirm('删除图片后所有此图片的引用将无法正常显示，请确认！', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      delMyImg({img_id:item.id},this,res=>{
        this.$message({
          type:'success',
          message:res.data.msg
        })
        this.getImglist()
      })
    }).catch(() => {       
    });
  },
  del_video(item,index){
    this.$confirm('删除视频后所有此视频的引用将无法正常显示，请确认！', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      del_video({id:item.id},this,res=>{
        this.$message({
          type:'success',
          message:res.data.msg
        })
        this.get_video_list()
      })
    }).catch(() => {       
    });
  },
  changevideoPage(val){
    console.log(val)
    this.page_video = val;
    this.get_video_list()
  },
  changeImgPage(val){
    console.log(val)
    this.page_img = val;
    this.getImglist()
  },
  get_video_list(){
    get_video_list({...this.filter,page:this.page_video,pagesize:this.pagesize},this,res=>{
      this.myvideo = res.data.list;
      this.video_group = res.data.group;
      this.myvideoCount=parseInt(res.data.count);
    })
  },
  getImglist(){
    Cookies.set(path,JSON.stringify(this.filter))
    var data = {...this.filter,page:this.page_img,pagesize:15};
    getImglist(data,this,res=>{
      this.myimgCount=parseInt(res.data.count);
      this.myimg = res.data.list;
      this.img_group = res.data.group;
      this.siteUrl = res.data.img_site_url;
    })
  },
}
}
</script>

<style lang="scss">

.myimg{
  .nulllist{
    min-height: 345px;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon{
      width: 100px !important;
      height: 100px !important;
      color: #ddd;
    }
  }
}
.video_icon{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  transition: all 0.2s;
  padding: 1px;
  position: absolute;
  z-index: 10;
  left: 50%;
  margin-left: -15px;
  top: 50%;
  margin-top: -15px;
  color: #fff;
  .icon{
    width: 100% !important; 
    height: 100% !important;
  }
}

.imgbox_{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  min-height: 345px;
}
.imgbox_ .section{
  width: 84px;
  margin-right: 20px;
  margin-bottom: 10px;
  position: relative;
}

.imgbox_ .section .delImg{
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  top: -7px;
  right: -7px;
  background: #ef2518;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  cursor: pointer;
  display: none;
  z-index: 10;
}
.imgbox_ .section:hover .delImg{
  display: flex;
}
.imgbox_ .section .img{
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  border: 1px solid #eee;
  overflow: hidden;
  justify-content: center;
  position: relative;
}
.imgbox_  .section .imgon{
  border: 1px solid #557ce1 !important;
}

.imgon .bottom{
  position: absolute;
  width: 100%;
  height: 50%;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
.check{
  display: none;
}
.imgon .check{
  display: block;
  position: absolute;
  bottom: -15px;
  right: -15px;
  width: 30px;
  height: 30px;
  transform: rotate(45deg);
  background: #557ce1;
  color: #fff;
}

.imgon .check .icon{
  transform: rotate(-45deg);
  width: 10px;
  height: 10px;
  margin-top: 10px;
  margin-left: 0px;
  color: #fff;
}
.imgbox_ .section .img .el-image{
  width: 100%
}
.imgbox_ .section .img .el-image .image-slot{
  color: #aaa;
}
.imgbox_ .section .label{
  font-size: 12px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
  margin-top: 5px;
}
.addimg{
  display: flex;
  align-items: flex-start;
}
.imgform{
  width: 100px;
  height: 100px;
  margin-top: 10px;
  margin-right: 10px;
  border: 1px solid #ddd;
  display: inline-block;
  position: relative;
  overflow: hidden;
}
.imgform:after{
  content: "×";
  position: absolute;
  left: 0;
  top: 0;
  font-size: 30px;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  opacity: 0;
  transition: all 0.2s;
  display: flex;
  color: #fff;
  justify-content: center;
  align-items: center;
}
.imgform:hover:after{
  opacity: 1;
  cursor: pointer
}
.imgform img{
  width: 100%;
  min-height: 98px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/media.vue